var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChatWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.58125 0 0 2.90937 0 6.5C0 8.05 0.66875 9.46875 1.78125 10.5844C1.39062 12.1594 0.084375 13.5625 0.06875 13.5781C0 13.65 -0.01875 13.7563 0.021875 13.85C0.0625 13.9438 0.15 14 0.25 14C2.32188 14 3.875 13.0063 4.64375 12.3938C5.66563 12.7781 6.8 13 8 13C12.4187 13 16 10.0906 16 6.5C16 2.90937 12.4187 0 8 0ZM4 7.5C3.44688 7.5 3 7.05312 3 6.5C3 5.94688 3.44688 5.5 4 5.5C4.55312 5.5 5 5.94688 5 6.5C5 7.05312 4.55312 7.5 4 7.5ZM8 7.5C7.44688 7.5 7 7.05312 7 6.5C7 5.94688 7.44688 5.5 8 5.5C8.55313 5.5 9 5.94688 9 6.5C9 7.05312 8.55313 7.5 8 7.5ZM12 7.5C11.4469 7.5 11 7.05312 11 6.5C11 5.94688 11.4469 5.5 12 5.5C12.5531 5.5 13 5.94688 13 6.5C13 7.05312 12.5531 7.5 12 7.5Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatWhite);
export default __webpack_public_path__ + "static/media/chat-white.75ffd08f72f30f4ebc3815824ebb8852.svg";
export { ForwardRef as ReactComponent };